import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrendTag } from '../../projects/preview/components/trend-tag/TrendTag';
import { getTrendValue, formatCount } from '../../../shared/utils/utils';
import BrandIcon from '../../../shared/components/brand-icon/BrandIcon';

interface BotPlatformCardProps {
  platform: string;
  value: number;
  /** number — percent vs previous period; null — "new" (no baseline to compare against) */
  trend: number | null;
  color: string;
  iconClass?: string | null;
}

const BotPlatformCard: React.FC<BotPlatformCardProps> = ({
  platform,
  value,
  trend,
  color,
  iconClass,
}) => {
  const { t } = useTranslation();
  const displayName = platform || t('botsActivity.unknownPlatform');

  return (
    <div className="crawl-platform-card">
      <div className="crawl-platform-card__header">
        <BrandIcon iconClass={iconClass} color={color} name={displayName} size="sm" />
        <span className="crawl-platform-card__name">{displayName}</span>
      </div>

      <div className="crawl-platform-card__value-row">
        <span className="crawl-platform-card__value">{formatCount(value)}</span>
        {trend !== null && <TrendTag trendValue={getTrendValue(trend)} suffix="%" />}
      </div>

      {trend !== null && (
        <div className="crawl-platform-card__period">{t('botsActivity.vsLastPeriod')}</div>
      )}
    </div>
  );
};

export default BotPlatformCard;
